import { render, staticRenderFns } from "./HelpVideos.vue?vue&type=template&id=39d015e8&scoped=true"
import script from "./HelpVideos.vue?vue&type=script&lang=js"
export * from "./HelpVideos.vue?vue&type=script&lang=js"
import style0 from "./HelpVideos.vue?vue&type=style&index=0&id=39d015e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d015e8",
  null
  
)

export default component.exports